"use strict";

exports.__esModule = true;
exports.paginationPropTypes = void 0;

var _propTypes = require("prop-types");

var _constants = require("./constants");

var paginationPropTypes = {
  currentPage: _propTypes.number.isRequired,
  messages: _propTypes.object,
  // TODO: improve using shape
  onPageChange: _propTypes.func.isRequired,
  onPageSizeChange: _propTypes.func,
  pageSize: _propTypes.number.isRequired,
  pageSizes: (0, _propTypes.arrayOf)(_propTypes.number),
  showPageJumper: _propTypes.bool,
  showPageNumbers: _propTypes.bool,
  showPageSizer: _propTypes.bool,
  size: (0, _propTypes.oneOf)(Object.keys(_constants.SIZE)),
  totalCount: _propTypes.number.isRequired,
  visibleRange: _propTypes.number
};
exports.paginationPropTypes = paginationPropTypes;